import request from "@/utils/request";

export default function agencyOpenCloseVideoChat(id,isEnableVideoChat) {
    return request({
        url: `/storeShop/agencyOpenCloseVideoChat/`+id+`/`+isEnableVideoChat,
        method: 'get'
    })
}